'use client';

import { useTheme } from 'next-themes';

import { cn } from '../lib/utils';
import { Button } from '../shadcn/button';

export function ButtonModeToggle(props: { className?: string }) {
  const { resolvedTheme, setTheme } = useTheme();

  const toggleTheme = () => {
    const next = resolvedTheme === 'dark' ? 'light' : 'dark';
    setTheme(next);
    setCookieTheme(next);
  };

  return (
    <Button
      variant="secondary"
      aria-label="Toggle theme"
      className={cn(props.className)}
      onClick={toggleTheme}
    >
      { resolvedTheme === 'dark' ? 'Light Mode Theme' : 'Dark Mode Theme' }
    </Button>
  );
}

function setCookieTheme(theme: string) {
  document.cookie = `theme=${theme}; path=/; max-age=31536000`;
}
